import { DbClient } from "@tanstack/db";
import { createIsomorphicFn } from "@tanstack/react-start";
import { queryClient } from "~/lib/query-client";
import { getRequestRuntime, getRequestLocale } from "./request-runtime.server";

const browserDbClient = new DbClient({ queryClient });

export const getAppQueryClient = createIsomorphicFn()
  .server(() => getRequestRuntime().queryClient)
  .client(() => queryClient);

export const getAppDbClient = createIsomorphicFn()
  .server(() => getRequestRuntime().dbClient)
  .client(() => browserDbClient);

export const getSsrLocale = createIsomorphicFn()
  .server(getRequestLocale)
  .client(() => undefined);

export const isServerRendering = createIsomorphicFn()
  .server(() => true)
  .client(() => false);

export const isSnapshotRendering = createIsomorphicFn()
  .server(() => getRequestRuntime().mode === "snapshot")
  .client(() => false);

/** A snapshot's clock anchors date-keyed queries across locale renders and hydration. */
export const getRenderTimeMs = createIsomorphicFn()
  .server(() => getRequestRuntime().renderTimeMs)
  .client(() => Date.now());
